import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import message from '../reducers/message-reducer';
import authorization from '../reducers/authorization-reducer';
import errors from '../reducers/errors-reducer';
import filters from '../reducers/filters-reducer';
import formalNotice from '../reducers/formalNotice-reducer';
import courtApplication from '../reducers/courtApplication-reducer';
import { combineReducers } from 'redux';
import persistState from 'redux-localstorage';

const rootReducer = combineReducers({
  message,
  authorization,
  errors,
  filters,
  formalNotice,
  courtApplication,
});

const loggerMiddleware = createLogger();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default (initialState) =>
  createStore(
    rootReducer,
    composeEnhancers(
      applyMiddleware(thunkMiddleware, loggerMiddleware),
      persistState(['authorization'])
    ),
    initialState
  );



// WEBPACK FOOTER //
// ./src/store/configure-store.js